import { useEffect } from "react";
import { useParams } from "@reach/router";
import { navigateActivation } from "../utils/url";
import useIsAuthenticated from "../../../hooks/use-is-authenticated";

export default function useRequireAuthenticated() {
  const isAuthenticated = useIsAuthenticated();
  const params = useParams();

  useEffect(() => {
    if (!isAuthenticated) {
      navigateActivation(
        params?.podKeyOrSerialNumber ? `${params.podKeyOrSerialNumber}/` : "/"
      );
    }
  }, [isAuthenticated]);
}
